
import Slider from "react-slick";

import Countdown from 'react-countdown';

 function Banner({eventInfo}:any) {
    var settings = {
        dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2500,
    cssEase: "linear",
    arrows: false
        };
        const Completionist = () => <span>You are good to go!</span>;
        const renderer = ({ days, hours, minutes, seconds, completed }) => {
            if (completed) {
              // Render a completed state
              return <Completionist />;
            } else {
              // Render a countdown
             // setDays(days);
             
              return <>
               <ul>
                            <li>
                                <h2 className="days">{days}</h2>
                                <span>Days</span>
                            </li>
                            <li>
                                <h2 className="hours">{hours}</h2>
                                <span>Hours</span>
                            </li>
                            <li>
                                <h2 className="minutes">{minutes}</h2>
                                <span>Minutes</span>
                            </li>
                            <li>
                                <h2 className="seconds">{seconds}</h2>
                                <span>Seconds</span>
                            </li>
                        </ul></>;
            }
          };
     return (
         <>

         {eventInfo.eventcode === "q4summit26" ? (
        <section
            style={{
                backgroundImage: eventInfo?.backgroundBanner?.imageUrl
                    ? `url(${eventInfo.backgroundBanner.imageUrl})`
                    : undefined,
                backgroundSize: "100% 100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                width: "100%",
                aspectRatio: "16 / 9"
            }}
            
            className="banner-section"
            id="home"
            data-scroll-index="0"
        >
        </section>
    ) : (

         <section   style={{
        backgroundImage: eventInfo?.backgroundBanner?.imageUrl 
          ? `url(${eventInfo.backgroundBanner.imageUrl})` 
          : undefined,
        backgroundSize: "cover",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center -40px'
      }} className={`banner-section ${eventInfo.eventcode === "acsc2026" ? "acsc2026-banner" : eventInfo.eventcode === "atp2026" ? "atp2026-banner" : ""}`} id="home" data-scroll-index="0">
        <div className="banner-carousel">
    
    <Slider  {...settings}>
            <div className="banner-slide">
                <div className="container">
                    <h2 className="bn-hd wow fadeInDown" data-wow-duration="100ms"><span>{eventInfo.startdate}</span></h2>
                    <h1 className="ben-head wow fadeInUp" data-wow-duration="300ms">{eventInfo.name}</h1>
                   <ul className="bn-links">
            
                        <li><a href={eventInfo.eventcode + "/register"} target="_blank" title="">Register Now</a></li>
                    </ul>
                </div>
            </div>

            {eventInfo.eventcode=="atp2026" && <>  <div className="banner-slide">
                <div className="container">
                <a href="/register" data-scroll-nav="8"><img className="img-fluid" src="../../images/Training.png" /></a>
                </div>
            </div> </>}
            
            {eventInfo.eventcode !== "atp2026" && (
            <div className="banner-slide">
                <div className="container">
                    <h2 className="bn-hd wow fadeInDown" data-wow-duration="100ms"><span>{eventInfo.startdate}</span></h2>
                    <h1 className="ben-head wow fadeInUp" data-wow-duration="300ms">{eventInfo.name}</h1>
                    <a href="https://youtu.be/GCEmss7Sm0w" target="_blank" title="" className="play-btn html5lightbox"><i className="fa fa-play"></i></a>
                </div>
            </div>)} {/* <!--banner-slide end--> */}
            
            <div className="banner-slide">
                <div className="container">
                    <h2 className="bn-hd wow fadeInDown" data-wow-duration="100ms"><span>{eventInfo.startdate}</span></h2>
                    <h1 className="ben-head wow fadeInUp" data-wow-duration="300ms">{eventInfo.name}</h1>
                    <div className="event-time-counter" id="clockdiv">
                    <Countdown date={new Date(eventInfo.startdate)} renderer={renderer} />
                       
                    </div>
                    <ul className="bn-links">
            
                        <li><a href={eventInfo.eventcode + "/register"} target="_blank" title="">Register Now</a></li>
                         <li><a href="https://youtu.be/GCEmss7Sm0w" target="_blank" title="">Watch Video</a></li>
                    </ul>
                    
                </div>
            </div>{/* <!--banner-slide end--> */}


            {/* <!--banner-slide end--> */}
           
            </Slider>
        </div> {/* <!--banner-carousel end--> */}
        <div className="container">
            <div className="contact-info-details">
                <div className="container">
                    <ul className="row">
                        <li className="col-lg-3 col-md-6 col-sm-6">
                            <span><i className="fa fa-calendar"></i></span>
                            <div className="con-info">
                                <h4>Date</h4>
                                <span>{eventInfo.startdate}</span>
                            </div> {/* <!--con-info end--> */}
                        </li>
                        <li className="col-lg-4 col-md-6 col-sm-6">
                            <span><i className="fa fa-map-marker"></i></span>
                            <div className="con-info">
                                <h4>Location</h4>
                                <span>{eventInfo.venuename}</span>
                            </div> {/* <!--con-info end--> */}
                        </li>
                    </ul>
                </div>
            </div> {/* <!-- contact-info-details end--> */}
        </div>
    </section>
)}
</>
);
}

export {Banner}